
import HeaderTemplate from "~/components/global/templates/HeaderTemplate";
export default {
    spacingDebug: true,
    components: {
        HeaderTemplate,
        ButtonTemplate: () => import("~/components/global/templates/ButtonTemplate"),
    },
    props: {
        sectionId: {
            type: String,
            default: "file-a-claim",
        },
        payload: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        heading() {
            const heading = this.payload?.heading || {};
            return {
                level: heading.level || "h2",
                textContent: heading.textContent || "",
                subtextContent: heading.subtextContent || "",
                alignment: heading.alignment || "center",
            };
        },
        cta() {
            return this.payload?.cta || {};
        },
    },
};
